import Phaser from 'phaser';
import type { Enemy } from './Enemy';

const BEAM_DEPTH = 95;
const BEAM_GLOW_ALPHA = 0.3;
const BEAM_GLOW_WIDTH_MULT = 3;

export class Beam {
  private readonly graphics: Phaser.GameObjects.Graphics;
  private readonly hitTestLine = new Phaser.Geom.Line();
  private readonly hitTestRect = new Phaser.Geom.Rectangle();
  private startX = 0;
  private startY = 0;
  private isOn = false;

  constructor(
    scene: Phaser.Scene,
    private readonly width: number,
    private readonly length: number,
    private readonly coreColor: number,
    private readonly glowColor: number,
  ) {
    this.graphics = scene.add.graphics();
    this.graphics.setDepth(BEAM_DEPTH);
    this.graphics.setVisible(false);
  }

  activate(): void {
    this.isOn = true;
    this.graphics.setVisible(true);
  }

  deactivate(): void {
    this.isOn = false;
    this.graphics.clear();
    this.graphics.setVisible(false);
  }

  isActive(): boolean {
    return this.isOn;
  }

  setOrigin(startX: number, startY: number): void {
    this.startX = startX;
    this.startY = startY;
  }

  redraw(): void {
    if (!this.isOn) return;
    this.graphics.clear();
    const endX = this.startX - this.length;

    this.graphics.lineStyle(this.width * BEAM_GLOW_WIDTH_MULT, this.glowColor, BEAM_GLOW_ALPHA);
    this.graphics.lineBetween(this.startX, this.startY, endX, this.startY);

    this.graphics.lineStyle(this.width, this.coreColor, 1);
    this.graphics.lineBetween(this.startX, this.startY, endX, this.startY);
  }

  // Враги, чьи AABB пересекает текущий луч. Урон применяется снаружи.
  getHitEnemies(enemies: Enemy[]): Enemy[] {
    if (!this.isOn) return [];
    const endX = this.startX - this.length;
    this.hitTestLine.setTo(this.startX, this.startY, endX, this.startY);
    const hits: Enemy[] = [];
    for (const enemy of enemies) {
      this.hitTestRect.setTo(
        enemy.x - enemy.width / 2,
        enemy.y - enemy.height / 2,
        enemy.width,
        enemy.height,
      );
      if (Phaser.Geom.Intersects.LineToRectangle(this.hitTestLine, this.hitTestRect)) {
        hits.push(enemy);
      }
    }
    return hits;
  }

  destroy(): void {
    this.graphics.destroy();
  }
}
